import React, { Component } from 'react';
import { BaseUserProfile } from 'fitbeat.models';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Platform, StyleSheet } from 'react-native';
import Theme from '../theme';
import { UserDataConsumer } from '../utils';
import { InvitePlatformCard } from '../ui';
import AllowedPartners from './AllowedPartners';
import { toggleUserProfileModalVisible } from '../ui/redux/uiActions';
import UserProfileModal from './components/UserProfileModal';

class CommunityPartners extends Component {

    state = {
        listType: undefined,
        isFetching: false,
        message: null,
    }

    setIsFetching = (isFetching) => {
        this.setState({isFetching});
    }

    setSuccessOrFailMessage = (message) => {
        this.setState({message})
    }

    openProfile = (listType, partner, onPress, isLoading, block, unblock) => {
        this.setState({ listType, partner, onPress, isLoading, block, unblock});
        this.props.toggleUserProfileModalVisible(true);
    }

    render() {
      const {t, user: {userProfile}} = this.props;
      return (
        <View style={{flex: 1}}>
          <View style={styles.container} className='full-height'>
            {BaseUserProfile.isFeatureEnabledForUser('alpha', userProfile) &&
              Platform.OS !== 'web' &&
              <InvitePlatformCard t={t} userProfile={userProfile}/>
            }
            {!this.props.isModalVisible &&
              <AllowedPartners
                openProfile={this.openProfile}
                setIsFetching={this.setIsFetching}
                setSuccessOrFailMessage={this.setSuccessOrFailMessage}
              />
            }
          </View>
            <UserProfileModal listType={this.state.listType} partner={this.state.partner} onPress={this.state.onPress}
                              block={this.state.block} unblock={this.state.unblock} isFetching={this.state.isFetching}
                              message={this.state.message} setSuccessOrFailMessage={this.setSuccessOrFailMessage}/>
        </View>
      );
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: Theme.WHITE,
    },
});

const mapDispatchToProps = (dispatch) => {
    return {
        toggleUserProfileModalVisible: (visible) => dispatch(toggleUserProfileModalVisible(visible)),
    }
}

CommunityPartners = connect(state => {
    return {
        isModalVisible: state.ui.userProfileModalVisible,
    };
}, mapDispatchToProps)(CommunityPartners)
CommunityPartners = translate(['workoutPartners'], { wait: true })(CommunityPartners);
export default UserDataConsumer(CommunityPartners);
